module.exports = __webpack_public_path__ + "static/media/chrome.b71492fe.png";